import { StyledInput } from '../StyledComponents';

export default StyledInput;
